<template>
    <div class="news-page">
        <div class="container">
            <div class="section-title-new" v-if="pageSetup != null">
                <!-- <h1>{{pageSetup.page_title}}</h1> -->
                <h1 v-if="lang == ''">НОВОСТИ</h1>
                <h1 v-if="lang == 'kz/'">ЖАҢАЛЫҚТАР</h1>
                <h1 v-if="lang == 'en/'">NEWS</h1>
                <div class="links-of-page">
                    <div class="link-item link-to-insta" v-if="!isMobileChecker">
                        <a :href="setup.btn_bazis_insta_home.link" target="_blank">
                            <span>{{ setup.btn_bazis_insta_home.desc }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </a>
                    </div>
                    <div class="link-item link-to-video">
                        <router-link to="/video">
                            <span>{{ setup.btn_bazis_video_home }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                    </div>
                </div>
            </div>
            <newsItems></newsItems>
            <transition
                name="fade"
                mode="out-in"
            >
                <div class="btn-pagination" v-if="!hidePaginBtn">
                    <a href="#" @click.prevent="paginationNews">
                        <span v-if="lang == ''">Загрузить еще</span>
                        <span v-if="lang == 'kz/'">Көбірек көрсету</span>
                        <span v-if="lang == 'en/'">Show more</span>
                    </a>
                </div>
            </transition>
        </div>
        <formPage class="form-page-news"></formPage>
    </div>
</template>

<script>
    // import sharePostBottom from '@/components/share/share-social-bottom.vue'
    import {mapGetters} from 'vuex'
    import newsItems from '@/components/news/news-item.vue'
	import formPage from '@/components/forms/form-page.vue';	
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import salesFilter from '@/components/realestate/sales-filter.vue'
    export default {
        name: 'news--page',
        components: {
            newsItems,
            formPage,
            svgIcon,
            // sharePostBottom,
        },
        data () {
            return {
                titlePage: 'Новости',
                count: 8,
                page: 1,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            pageSetup: 'loadNewsPage',
            setup: 'loadPageSetUp',
            newsPageCount: 'loadNewsPageCount',
            hidePaginBtn: 'loadHidePaginBtn',
            titleSite: 'loadSiteTitle',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            paginationNews() {
                // this.count = this.count + 2;
                this.page = this.page + 1;
                if (this.page < this.newsPageCount) {
                    this.ajaxInit();
                } else if (this.page == this.newsPageCount) {
                    this.ajaxInit();
                }

                if (this.page >= this.newsPageCount) {
                   this.$store.commit('HidePaginBtn', true); 
                }
               
               
                // console.log(this.count, 'NEWS')
            },
            ajaxInit() {
                axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?per_page=' + this.count + '&page=' + this.page).then(async (response) => {
                    // console.log(response)
                    this.$store.commit('newsItems', response.data);
                });
            }
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getNewsPageData');
            if (store.state.newsItems != null) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getNewsItems').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'news';
        },
        created () {
            document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news/news.scss';
    @import '@/styles/respond/news/news-respond.scss';
</style>